<template>
      <div id="thiscanvas" ref='canvas' />
</template>

<script>

import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'


export default {
  name: "Bitterbal",

  data: function() {
  const scene = new THREE.Scene()
  const camera = new THREE.PerspectiveCamera(75,window.innerWidth / window.innerHeight,0.1,1000)
  const renderer = new THREE.WebGLRenderer({ antialias: true })

  const geometry = new THREE.SphereBufferGeometry(2, 30, 30);
  const geometryWireFrame = new THREE.SphereBufferGeometry(2.1, 60, 60);

  const BaseTexture = new THREE.TextureLoader().load('https://api.enter.hetnieuweinstituut.nl/uploads/TEXTURE_diffuse_Original_5afb72209e.jpg');
  const NormalMap = new THREE.TextureLoader().load('https://api.enter.hetnieuweinstituut.nl/uploads/TEXTURE_normal_7622287254.jpg');
  const HeightMap = new THREE.TextureLoader().load('https://api.enter.hetnieuweinstituut.nl/uploads/ball_texture_434d1e834c.jpeg');

  const annotation = document.getElementById("annotation");

  const material = new THREE.MeshStandardMaterial({ 
      map: BaseTexture,
      normalMap: NormalMap,
      displacementMap: HeightMap,
      displacementScale: .1
  });

  const materialforWireFrame = new THREE.MeshStandardMaterial({ 
    wireframe: true, opacity: .5,
    color: 0x70ffd4,
    normalMap: NormalMap,
    displacementMap: HeightMap,
    displacementScale: .1,

  });

  const color = 0xFFFFFF;
  const intensity = 1;
  const light = new THREE.AmbientLight(color, intensity);
  

  const cube = new THREE.Mesh( geometry, material )
  const cube2 = new THREE.Mesh( geometryWireFrame, materialforWireFrame )

  const line = new THREE.LineSegments(
    new THREE.WireframeGeometry(geometry),
    new THREE.LineBasicMaterial({
      color: 0xffffff,
      linewidth: 1,
      opacity: 0.5,
      transparent: true
    })
  );

  const controls = new OrbitControls( camera, renderer.domElement );

  return {
    scene: scene,
    camera: camera,
    renderer: renderer,
    light: light,
    cube: cube,
    cube2: cube2,
    line:line,
    controls: controls,
    annotation: annotation,

    bitterBal:false,
  }
  
},

  created: function() {
    // console.log( "Bitterbal Created");
    // this.cssScene.add(this.cssObject);
    this.scene.add(this.camera)
    this.scene.add(this.light)
    this.scene.add(this.cube)
    // this.scene.add(this.cube2)
    this.scene.add(this.line);
    this.scene.add(this.planeMesh);

    this.renderer.setSize(window.innerWidth, window.innerHeight)
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setClearColor( 0x0e2633, 1 )

    this.scene.background = new THREE.Color('hsl(0, 100%, 100%)')

    this.camera.position.set( 0,4,4 );
    this.controls.update();

  },

  mounted: function() {
    // console.log("mounted")
    this.annotation = document.getElementById("annotation");
    this.$refs.canvas.appendChild(this.renderer.domElement)
    this.animate()
  },

  methods: {

    animate: function() {
      requestAnimationFrame(this.animate)
      this.renderer.render(this.scene, this.camera)
      this.cube.rotation.y += 0.001;
      this.render();
    },

    render: function(){
      this.updateAnnotationPosition();
      // console.log(this.annotation);
    },  

    updateAnnotationPosition(){
      // console.log('update')
      const canvas = this.renderer.domElement;

      // const vector = new THREE.Vector3(250, 250, 250);
      // vector.project(this.camera);
      // vector.x = Math.round((0.5 + vector.x / 2) * (canvas.width / window.devicePixelRatio));
      // vector.y = Math.round((0.5 - vector.y / 2) * (canvas.height / window.devicePixelRatio));

      // console.log(vector.x, vector.y)      
      // console.log(vector);

      // this.annotation.style.top = `${vector.y}px`;
      // this.annotation.style.left = `${vector.x}px`;
    },


  },

  computed: {
    rotate: function() {
      if (this.speed === '') {
        return 0
      } else {
        return this.speed
      }
    }
  },



}
</script>

<style>


canvas{
  width: 500px;
  height: 500px;
}

#leaveRoom{
  position: fixed;
  bottom: 10px;
  right: 5%;
  z-index:1000;
  text-align: right;
  color:rgb(235, 235, 235);
  background-color: #464646;
}

#leaveRoom:hover{
  background-color:purple;
}


#controls{
  position: fixed;
  bottom: 10px;
  left: 5%;
  z-index:1000;
  text-align: left;
  background:green;
}

#controls div{
  color: white; 
}

#controls div:hover{
  /* background-color:purple; */
  /* color:white; */
}

#annotation{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  margin-left: 15px;
  margin-top: 15px;
  padding: 1em;
  width: 200px;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 4em;
  font-size: 12px;
  line-height: 1.2;
  transition: opacity .5s;




}

#annotation::before {
      content: 'IBO';
      position: absolute;
      top: -30px;
      left: -30px;
      width: 30px;
      height: 30px;
      border: 2px solid #fff;
      border-radius: 50%;
      font-size: 16px;
      line-height: 30px;
      text-align: center;
      background: rgba(0, 0, 0, 0.8);
  }


.selector{
  position: fixed;
  z-index: 1000;
}



</style>